module.exports = __webpack_public_path__ + "img/icn_brand13_black.270d9245.svg";